<body>
  <router-outlet></router-outlet>
  <ngx-spinner type="ball-newton-cradle" [fullScreen]="true" size="medium" color="#fff">
    <p style="color: white">
      {{ (mensagemSpinner$ | async) || 'Carregando...' }}
    </p>
  </ngx-spinner>
</body>
